import { getInitiativeJiraIssuesSelector } from '../../@arch/selectors';
import { InitiativeStatusSelector } from '../../StatusSelector';
import { coreActions, FeatureFlag } from '@sonar-software/sonar-core';
import React, { useCallback, useMemo } from 'react';
import { useAction, useFeatureFlag, useInterval, useSonarSelector } from '@hooks';
export const InitiativeSidebarStatusSelector = ({ initiativeId, status }) => {
    const jiraEnabled = useFeatureFlag(FeatureFlag.JiraIntegration);
    const jiraIssueData = useSonarSelector(getInitiativeJiraIssuesSelector.data);
    const jiraStatusSync = useMemo(() => jiraEnabled && (jiraIssueData === null || jiraIssueData === void 0 ? void 0 : jiraIssueData.some((issue) => issue.isSynced)), [jiraEnabled, jiraIssueData]);
    const getInitiative = useAction(coreActions.requestGetCoreInitiativesById);
    const refreshInitiative = useCallback(() => {
        if (jiraStatusSync) {
            getInitiative({
                id: initiativeId
            });
        }
    }, [getInitiative, initiativeId, jiraStatusSync]);
    useInterval(refreshInitiative, 10000);
    const updateInitiative = useAction(coreActions.requestPatchCoreInitiativesById);
    const handleChangeStatus = useCallback((statusId) => {
        updateInitiative({
            initiativeId: initiativeId,
            patchInitiativeDescription: {
                initiativeStatusId: statusId
            }
        });
    }, [initiativeId, updateInitiative]);
    return (React.createElement(InitiativeStatusSelector, { disabled: jiraStatusSync, id: 'initiative-status-select', onChange: handleChangeStatus, value: status }));
};
